if (process.env.NODE_ENV === "production") {
  import("./lib/fullstory.mjs");
}

// URL search keys that should be hidden from the user
const hiddenSearchKeys = ["pmId", "origin", "sandbox", "serverType", "heightListenerReady", "parentUrlBase"];

const PLUGIN_BASE = "/listings-plugin";

// URL search keys that should be cleared when the user clears the filter
const clearableFilterKeys = [
  "mbN",
  "mbE",
  "mbS",
  "mbW",
  "minBeds",
  "minBaths",
  "minPrice",
  "maxPrice",
  "cats",
  "dogs",
  "sortBy",
  "descending",
  "availableNow",
];

let iframe;
let heightListenerReady = false;
let lvButton;
let mvButton;

function bindMobileViewButtons() {
  mvButton = document.querySelector("button.ender-mobile-view-button.mv");
  lvButton = document.querySelector("button.ender-mobile-view-button.lv");

  mvButton.addEventListener("click", () => {
    document.body.classList.add("mv-visible");
    document.body.classList.remove("lv-visible");

    const updatedUrl = new URL(iframe.src);
    updatedUrl.searchParams.set("searchView", "map");
    iframe.src = updatedUrl.toString();
  });

  lvButton.addEventListener("click", () => {
    document.body.classList.add("lv-visible");
    document.body.classList.remove("mv-visible");

    const updatedUrl = new URL(iframe.src);
    updatedUrl.searchParams.set("searchView", "list");
    iframe.src = updatedUrl.toString();
  });
}

function getCurrentSearchView() {
  const url = new URL(iframe.src);
  return url.searchParams.get("searchView") ?? "list";
}

/**
 * Toggles the visibility of the mobile view buttons based on the href
 * @param {string} href The href to check
 */
function toggleVisibilityMobileViewButtons(href) {
  const url = new URL(href);
  const cleanPathname = url.pathname.replace(iframe?.dataset?.url || "", "");

  if (!lvButton || !mvButton) {
    bindMobileViewButtons();
  }

  if (cleanPathname.match("/search")) {
    const searchView = getCurrentSearchView();
    const viewClass = searchView === "list" ? "lv-visible" : "mv-visible";
    document.body.classList.add("ender-search-page", viewClass);
  } else {
    document.body.classList.remove(
      "ender-search-page",
      "mv-visible",
      "lv-visible",
    );
  }
}

/**
 * Creates a new iframe with the given src in place of the old one
 * @param {*} newUrl The new iframe src
 */
function changeIframeSrc(newUrl) {
  // newUrl will include search params right? Have nextJS side construct the new one
  const container = document.querySelector(".iframe-container");
  const newIframe = iframe.cloneNode();
  newIframe.src = newUrl;

  // for loop of iframe.dataset key value pairs
  for (const [key, value] of Object.entries(iframe.dataset)) {
    newIframe.dataset[key] = value;
  }

  container.replaceChild(newIframe, iframe);
  iframe = newIframe;

  toggleVisibilityMobileViewButtons(window.location.href);
}

function updateUrl(newUrl, replace) {
  changeIframeSrc(newUrl);

  const url = new URL(newUrl);
  const oldUrl = new URL(window.location.href);

  const pathname = url.pathname.replace(PLUGIN_BASE, "");
  const oldPathname = oldUrl.pathname.replace(PLUGIN_BASE, "");

  if (oldPathname !== pathname) {
    scrollToTop();
  }

  toggleVisibilityMobileViewButtons(newUrl);

  const browserSearch = new URLSearchParams(url.search);

  const origin = browserSearch.get("origin");

  hiddenSearchKeys.forEach((key) => {
    browserSearch.delete(key);
  });

  const newState = origin + [pathname, browserSearch.toString()].join("?");

  if (replace) {
    window.history.replaceState({}, "", newState);
  } else {
    window.history.pushState({}, "", newState);
  }
}

function updateSearchParams(search, replace) {
  const params = new URLSearchParams(search);

  const url = new URL(window.location.href);

  for (const [key, value] of params) {
    if (value === null) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
  }

  // Cannot communicate null values between next app and iframe
  for (const clearableKey of clearableFilterKeys) {
    if (!params.has(clearableKey)) {
      url.searchParams.delete(clearableKey);
    }
  }

  hiddenSearchKeys.forEach((key) => {
    url.searchParams.delete(key);
  });

  if (replace) {
    window.history.replaceState({}, "", url);
  } else {
    window.history.pushState({}, "", url);
  }
}

window.addEventListener("load", () => {
  iframe = document.querySelector("iframe");
});

window.addEventListener("popstate", () => {
  const newUrl = new URL(window.location.href);

  const oldUrl = new URL(iframe.src);
  const newParams = newUrl.searchParams;

  for (const key of hiddenSearchKeys) {
    newParams.set(key, oldUrl.searchParams.get(key));
  }

  let pathname = newUrl.pathname.replace(`${iframe.dataset.url}/`, "");

  if (pathname.endsWith("/")) {
    pathname = pathname.slice(0, -1);
  }

  const iframeSrc = `${iframe.dataset.urlBase}/listings-plugin${[pathname, newParams.toString()].join("?")}`;
  changeIframeSrc(iframeSrc);
});

async function submitContactForm(formData) {
  const url = `${window.location.origin}/wp-admin/admin-ajax.php`;

  await fetch(url, {
    method: "POST",
    body: formData,
  });
}

function scrollToCenter() {
  if (!iframe) {
    return;
  }

  const iframeOffsetTop = iframe.offsetTop;
  const iframeCenter = iframeOffsetTop + iframe.offsetHeight / 2;

  window.scrollTo(0, iframeCenter - window.innerHeight / 2);
}

function scrollToTop() {
  if (!iframe) {
    return;
  }

  const iframeOffsetTop = iframe.offsetTop;
  window.scrollTo(0, iframeOffsetTop);
}

function scrollToBottom() {
  if (!iframe) {
    return;
  }

  const iframeRect = iframe.getBoundingClientRect();
  const iframeBottom = iframeRect.bottom + window.scrollY;

  window.scrollTo(0, iframeBottom - window.innerHeight);
}

function setIframeHeight(height) {
  if (!iframe) {
    return;
  }

  const newHeight = `${height}px`;

  if (iframe.style.height === newHeight) {
    return;
  }

  iframe.style.height = newHeight;
}

window.addEventListener("message", (event) => {
  let whileCount = 0;
  while (!iframe) {
    // do nothing
    whileCount++;
    if (whileCount > 10000) {
      throw new Error("Iframe not found");
    }
  }
  if (event.data.source === "ender") {
    switch (event.data.action) {
      case "setHeight":
        setIframeHeight(event.data.height);
        break;
      case "submitContactForm":
        submitContactForm(event.data.formData);
        break;
      case "scrollToCenter":
        scrollToCenter();
        break;
      case "scrollToTop":
        scrollToTop();
        break;
      case "scrollToBottom":
        scrollToBottom();
        break;
      case "setUrl":
        updateUrl(event.data.url, event.data.replace);
        break;
      case "setSearchParams":
        updateSearchParams(event.data.search, event.data.replace);
        break;
    }
  }

  if (iframe && !heightListenerReady) {
    heightListenerReady = true;
    const iframeSrc = new URL(iframe.src);
    iframeSrc.searchParams.set("heightListenerReady", "true");
    changeIframeSrc(iframeSrc.toString());
  }
});
